"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrganizationPageNewsletterCanonicalTags = exports.getOrganizationPageCanonicalTags = exports.getTicketingCanonicalTags = exports.getDonationFormCanonicalTags = void 0;
const locales_1 = require("../internationalization/features/locales");
const routes_1 = require("../routes");
const locales_2 = require("./locales");
const getDonationFormCanonicalTags = ({ frontendUrl, donationForm, fieldsLocales, country, }) => {
    const isoLocales = (0, locales_2.getIsoLocalesFromFields)(fieldsLocales, country);
    const mainIsoLocale = (0, locales_1.getIsoLocaleFromCountry)(country, donationForm.locale);
    const alternateIsoLocales = isoLocales.filter((isoLocale) => isoLocale !== mainIsoLocale);
    const mainUrl = `${frontendUrl}${(0, routes_1.getFormLink)(donationForm, mainIsoLocale)}`;
    return {
        url: mainUrl,
        default: mainUrl,
        alternate: alternateIsoLocales.reduce((acc, isoLocale) => {
            acc[isoLocale] = `${frontendUrl}${(0, routes_1.getFormLink)(donationForm, isoLocale)}`;
            return acc;
        }, {}),
    };
};
exports.getDonationFormCanonicalTags = getDonationFormCanonicalTags;
const getTicketingCanonicalTags = ({ frontendUrl, ticketing, fieldsLocales, country, }) => {
    const isoLocales = (0, locales_2.getIsoLocalesFromFields)(fieldsLocales, country);
    const mainIsoLocale = (0, locales_1.getIsoLocaleFromCountry)(country, ticketing.locale);
    const alternateIsoLocales = isoLocales.filter((isoLocale) => isoLocale !== mainIsoLocale);
    const mainUrl = `${frontendUrl}${(0, routes_1.getTicketingLink)(ticketing.path, mainIsoLocale)}`;
    return {
        url: mainUrl,
        default: mainUrl,
        alternate: alternateIsoLocales.reduce((acc, isoLocale) => {
            acc[isoLocale] = `${frontendUrl}${(0, routes_1.getTicketingLink)(ticketing.path, isoLocale)}`;
            return acc;
        }, {}),
    };
};
exports.getTicketingCanonicalTags = getTicketingCanonicalTags;
const getOrganizationPageCanonicalTags = ({ frontendUrl, organizationPage, fieldsLocales, country, }) => {
    const isoLocales = (0, locales_2.getIsoLocalesFromFields)(fieldsLocales, country);
    const mainIsoLocale = (0, locales_1.getIsoLocaleFromCountry)(country, organizationPage.locale);
    const alternateIsoLocales = isoLocales.filter((isoLocale) => isoLocale !== mainIsoLocale);
    const mainUrl = `${frontendUrl}${(0, routes_1.getOrganizationPageLink)(organizationPage.path, mainIsoLocale)}`;
    return {
        url: mainUrl,
        default: mainUrl,
        alternate: alternateIsoLocales.reduce((acc, isoLocale) => {
            acc[isoLocale] = `${frontendUrl}${(0, routes_1.getOrganizationPageLink)(organizationPage.path, isoLocale)}`;
            return acc;
        }, {}),
    };
};
exports.getOrganizationPageCanonicalTags = getOrganizationPageCanonicalTags;
const getOrganizationPageNewsletterCanonicalTags = ({ newsletterId, ...organizationPageTagsParams }) => {
    const organizationPageTags = (0, exports.getOrganizationPageCanonicalTags)(organizationPageTagsParams);
    return {
        url: (0, routes_1.getOrganizationPageNewsletterUrl)(organizationPageTags.url, newsletterId),
        default: (0, routes_1.getOrganizationPageNewsletterUrl)(organizationPageTags.default, newsletterId),
        alternate: Object.fromEntries(Object.entries(organizationPageTags.alternate ?? {}).map(([isoLocale, url]) => [
            isoLocale,
            (0, routes_1.getOrganizationPageNewsletterUrl)(url, newsletterId),
        ])),
    };
};
exports.getOrganizationPageNewsletterCanonicalTags = getOrganizationPageNewsletterCanonicalTags;
